import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { Content, DashList, DataListWrap, Img, Td, TitleLeft } from './KohortDetails.styled';
import { useStore } from '@store/appStore';
import Pagination from '../Pagination';
import SortArrow from '../SortArrow';
import fixedNumber from '@utils/fixedNumber';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import EmptyBox from '../EmptyBox';
import { FlexRow } from '../StudentDetails/StudentDetails.styled';
import Tendency from '../StudentDetails/Tendency';
import { ShowabsenceOrAttendance } from '@utils/percentageTools';
import Tooltip from '@components/Tooltips/Tooltip';
import { GenerateExcelFile } from '../excel';
import moment from 'moment';
import StudentThumbnail from '@components/StudentThumbnail';
import db from '@utils/db';
import { set } from 'js-cookie';

interface IProps { getKohorts: () => void, loading: boolean }

export const KohortDetails = forwardRef((props: IProps, ref) => {
  useImperativeHandle(ref, () => ({
    exportExcel() {
      Excel()
    },
  }));
  const { schoolViewKohorts, setSelectedKohort, selectedKohort, client, settings, callNameSetting, filterDate, schoolViewCourses, schoolViewFilter, page, setPage, setSchoolViewFilter } = useStore();
  const i18n = useI18n()
  const [sort, setSort] = useState({ type: 0, direction: false })
  const pageSize = 13;
  const [kohortStudents, setKohortStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [kohortStudentPage, setKohortStudentPage] = useState(1);
  const [searchBackup, setSearchBackup] = useState("");
  const [percentageBackup, setPercentageBackup] = useState(0);
  const [studentSort, setStudentSort] = useState({ type: 0, direction: false })

  useEffect(() => {
    getKohorts()
  }, [filterDate])

  const getKohorts = async () => {
    await props.getKohorts()
  }

  const getFilteredKohorts = () => {
    let kohortsTemp = JSON.parse(JSON.stringify(schoolViewKohorts))
    kohortsTemp = kohortsTemp
      ?.filter(s => {
        let p = (settings.SHOWPRESENCE ? (100 - schoolViewFilter.percentage8) : schoolViewFilter.percentage8)
        p = p == 100 ? 0 : p;
        return s.kohort_percentage >= p
      })
      ?.filter(s => s.kohort_name?.toLowerCase().includes(schoolViewFilter.search8?.toLowerCase()))
    return kohortsTemp
  }

  function handleSort(type, student = false) {
    let direction = false;
    if (student) {
      if (type === studentSort.type) direction = !studentSort.direction
      setStudentSort({ type: type, direction: direction })
    }
    else {
      if (type === sort.type) direction = !sort.direction
      setSort({ type: type, direction: direction })
    }
  }

  function getSortedKohorts() {
    let coursesTemp = getFilteredKohorts()
    coursesTemp = coursesTemp?.sort((a, b) => {
      let dir = sort.direction ? -1 : 1
      switch (sort.type) {
        case 0:
          if (a.kohort_name > b.kohort_name) return 1 * dir
          else if (a.kohort_name < b.kohort_name) return -1 * dir
          else return 0
        case 1:
          if (a.kohort_description > b.kohort_description) return 1 * dir
          else if (a.kohort_description < b.kohort_description) return -1 * dir
          else return 0
        case 2:
          if (a.percentage > b.percentage) return 1 * dir
          else if (a.percentage < b.percentage) return -1 * dir
          else return 0
        case 3:
          if (a.kohort_student_count > b.kohort_student_count) return 1 * dir
          else if (a.kohort_student_count < b.kohort_student_count) return -1 * dir
          else return 0
      }
    })
    return coursesTemp
  }

  const getFilteredKohortstudents = () => {
    let kohortsTemp = JSON.parse(JSON.stringify(kohortStudents))
    kohortsTemp = kohortsTemp
      ?.filter(s => {
        let p = (settings.SHOWPRESENCE ? (100 - schoolViewFilter.percentage8) : schoolViewFilter.percentage8)
        p = p == 100 ? 0 : p;
        return s.kohort_percentage >= p
      })
      ?.filter(s => s.displayname?.toLowerCase().includes(schoolViewFilter.search8?.toLowerCase()))
    console.log("kohortsTemp", kohortsTemp)
    return kohortsTemp
  }

  function getSortedKohortstudents() {
    let coursesTemp = getFilteredKohortstudents()
    coursesTemp = coursesTemp?.sort((a, b) => {
      let dir = studentSort.direction ? -1 : 1
      switch (studentSort.type) {
        case 0:
          if (a.displayname > b.displayname) return 1 * dir
          else if (a.displayname < b.displayname) return -1 * dir
          else return 0
        case 1:
          if (a.kohort_percentage > b.kohort_percentage) return 1 * dir
          else if (a.kohort_percentage < b.kohort_percentage) return -1 * dir
          else return 0
      }
    })
    return coursesTemp
  }


  const getTextCount = () => {
    if (selectedKohort !== null) {
      let count = getFilteredKohortstudents()?.length
      let totalCount = kohortStudents?.length
      if (totalCount === count && count > 0) {
        return `${i18n.t('showing')} ${i18n.t('all').toLowerCase()} ${totalCount}`
      }
      else {
        if (count > 0) {
          return `${i18n.t('showing')} ${count} ${i18n.t('of')} ${totalCount}`
        }
        else
          return ""
      }
    }
    else {
      let count = getFilteredKohorts()?.length
      let totalCount = schoolViewKohorts?.length
      if (totalCount === count && count > 0) {
        return `${i18n.t('showing')} ${i18n.t('all').toLowerCase()} ${totalCount}`
      }
      else {
        if (count > 0) {
          return `${i18n.t('showing')} ${count} ${i18n.t('of')} ${totalCount}`
        }
        else
          return ""
      }
    }
  }

  useEffect(() => {
    if (selectedKohort !== null) {
      getKohortStudents(selectedKohort.kohort_id)
      setSearchBackup(schoolViewFilter.search8)
      setPercentageBackup(schoolViewFilter.percentage8)
      let tempFilter = JSON.parse(JSON.stringify(schoolViewFilter))
      tempFilter.search8 = ""
      tempFilter.percentage8 = 0
      setSchoolViewFilter(tempFilter)
    }
    else {
      let tempFilter = JSON.parse(JSON.stringify(schoolViewFilter))
      tempFilter.search8 = searchBackup
      tempFilter.percentage8 = percentageBackup
      setPercentageBackup(0)
      setSearchBackup("")
      setSchoolViewFilter(tempFilter)
      setKohortStudents([])
    }
  }, [selectedKohort])

  const getKohortStudents = async (kohortId) => {
    setLoading(true)
    let students = await db.KohortGetPercentages(JSON.stringify([{ kohort_id: kohortId }]))
    setKohortStudents(students)
    setLoading(false)
  }

  const Excel = () => {
    let data = []
    let headers = []
    if (selectedKohort !== null) {
      data = getSortedKohortstudents().map(r => {
        let object = {}
        object[i18n.t("header-name")] = r.displayname;
        object[i18n.t(settings.SHOWPRESENCE ? "header-kohort-attendance" : "header-kohort-absence")] = ShowabsenceOrAttendance(settings.SHOWPRESENCE, fixedNumber(r.kohort_percentage));
        return object;
      });

      headers = [
        i18n.t("header-name"),
        i18n.t(settings.SHOWPRESENCE ? "header-kohort-attendance" : "header-kohort-absence")
      ];
    }
    else {
      data = getSortedKohorts().map(r => {
        let object = {}

        object[i18n.t("kohort-displayname")] = r.kohort_name;
        object[i18n.t(settings.SHOWPRESENCE ? "header-kohort-attendance" : "header-kohort-absence")] = ShowabsenceOrAttendance(settings.SHOWPRESENCE, fixedNumber(r.kohort_percentage));
        object[i18n.t("header-amount-" + callNameSetting)] = r.kohort_student_count;
        return object;
      });

      headers = [
        i18n.t("kohort-displayname"),
        i18n.t(settings.SHOWPRESENCE ? "header-kohort-attendance" : "header-kohort-absence"),
        i18n.t("header-amount-" + callNameSetting)
      ];
    }

    let name = selectedKohort ? selectedKohort.kohort_name : i18n.t("kohorts")

    GenerateExcelFile(name + "_" + moment().format('DD-MM-YYYY-HHmm'), headers, data, i18n.t("kohorts") + "_" + moment().format('DD-MM-YYYY-HHmm'));
  }

  const handleClick = (kohort) => {
    setKohortStudentPage(1)
    setSelectedKohort(kohort)
  }

  return (<>
    <Content>
      <TitleLeft>
        <span>{i18n.t("kohorts")}</span>
        <span>{getTextCount()}</span>
      </TitleLeft>

      {props.loading || loading ? <RainbowLoader /> : (selectedKohort ? getSortedKohortstudents()?.length : getSortedKohorts()?.length) > 0 ? <><DataListWrap>
        {selectedKohort !== null ? <h1>{selectedKohort.kohort_name} (<button onClick={() => handleClick(null)}>x</button>)</h1> : null}
        <DashList>
          {selectedKohort === null ? <tbody>
            <tr>
              <Td className={"width40"} onClick={() => handleSort(0)}>{i18n.t("kohort-displayname")} <SortArrow sortActive={sort.type === 0} asc={sort.type === 0 && sort.direction === false} /></Td>
              <Td className={"width40"} onClick={() => handleSort(1)}>{i18n.t("kohort-description")} <SortArrow sortActive={sort.type === 1} asc={sort.type === 1 && sort.direction === false} /></Td>
              <Td className={"right width20"} onClick={() => handleSort(2)}>{i18n.t(settings.SHOWPRESENCE ? "header-kohort-attendance" : "header-kohort-absence")} <SortArrow sortActive={sort.type === 1} asc={sort.type === 1 && sort.direction === false} /></Td>
              <Td className={"right width20"} onClick={() => handleSort(3)}>{i18n.t("header-amount-" + callNameSetting)} <SortArrow sortActive={sort.type === 2} asc={sort.type === 2 && sort.direction === false} /></Td>
            </tr>
            {schoolViewKohorts ? getSortedKohorts().slice((page * pageSize - pageSize), pageSize * page).map((r, index) => <tr key={"kohort_" + index}>
              <td className={"width40 clickable"} onClick={() => handleClick(r)}><Tooltip placement='top-start' content={i18n.t("show-details-kohort")}>{r.kohort_name}</Tooltip></td>
              <td className={"width40 clickable"} onClick={() => handleClick(r)}><Tooltip placement='top-start' content={i18n.t("show-details-kohort")}>{r.kohort_description}</Tooltip></td>
              <td className={"right width20"}><span><FlexRow className={"p-right"}>{ShowabsenceOrAttendance(settings.SHOWPRESENCE, fixedNumber(r.kohort_percentage))}%<Tendency tendencyUp={false} courseId={r.kohort_id} /></FlexRow></span></td>
              <td className={"right width20"}><span className={"p-right"}>{r.kohort_student_count}</span></td>
            </tr>) : null}
          </tbody> : <tbody>
            <tr>
              <td className={"imgWidth"} ></td>
              <Td className={"width50"} onClick={() => handleSort(0, true)}>{i18n.t("header-name")} <SortArrow sortActive={studentSort.type === 0} asc={studentSort.type === 0 && studentSort.direction === false} /></Td>
              <Td className={"right"} onClick={() => handleSort(1, true)}>{i18n.t(settings.SHOWPRESENCE ? "header-kohort-attendance" : "header-kohort-absence")} <SortArrow sortActive={studentSort.type === 1} asc={studentSort.type === 1 && studentSort.direction === false} /></Td>
            </tr>
            {getSortedKohortstudents()?.length > 0 ? getSortedKohortstudents().slice((kohortStudentPage * pageSize - pageSize), pageSize * kohortStudentPage).map((r, index) => <tr key={"kohort_student_" + index}>
              <td className={"imgWidth"}><Img><StudentThumbnail font={"0.9em"} name={r.displayname} src={r.username} /></Img></td>
              <td className={"width50"}>{r.displayname}</td>
              <td className={"right"}><span className={"p-right"}>{ShowabsenceOrAttendance(settings.SHOWPRESENCE, fixedNumber(r.kohort_percentage))}%</span></td>
            </tr>) : <tr>
              <td colSpan={3} style={{ textAlign: 'center' }}>{i18n.t("no-students-in-kohort")}</td>
            </tr>}
          </tbody>}
        </DashList>
      </DataListWrap>
        <Pagination pageSize={pageSize} count={selectedKohort ? getSortedKohortstudents()?.length : getSortedKohorts()?.length} currentPage={selectedKohort ? kohortStudentPage : page} maxPage={Math.ceil((selectedKohort ? getSortedKohortstudents()?.length : getSortedKohorts()?.length) / pageSize)} setPage={selectedKohort ? setKohortStudentPage : setPage} /></> : <EmptyBox Graphic='documents' marvin={true} text={i18n.t("no-filter-data")} />}
    </Content>
  </>);
});

export default KohortDetails;
